<template>
    <div class="EventInfo spackage bgc box-shadow padding-20">
        <div class="event_box">
            <img :src="eventInfoData.coverurl" alt="">
            <div class="event_info_box">
                <p>{{eventInfoData.subject}}</p>
                <p>{{eventInfoData.ispublic==1?'公开':'不公开'}} {{eventInfoData.coursetypetext}}</p>
                <p>{{eventInfoData.feetypetext=='收费'?'￥'+eventInfoData.saleprice:eventInfoData.feetypetext}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "culumTop",
        props:['eventInfoData']
    }
</script>

<style scoped lang="scss">
    .EventInfo {
        .event_box {
            background-color: #FAFAFA;
            display: flex;
            padding: 22px 20px;
            &>img {
                width: 180px;
                height: 102px;
                margin-right: 30px;
            }
            .event_info_box {
                p {
                    font-size:15px;
                    line-height: 21px;
                }
                p:nth-of-type(1){
                    color: #303133;
                    font-size:16px;
                    line-height: 22px;
                    font-weight: bold;
                }
                p:nth-of-type(2){
                    color: #606266;
                    margin: 12px 0;
                }
                p:nth-of-type(3){
                    color: #FF4747;
                }
            }
        }
    }
</style>
